import pxToRem from "assets/theme/functions/pxToRem";
import check from "../../../assets/icons/check.svg";
export const DoneText = ({palette: {tertiary}}) => ({
  color: tertiary.main,
  cursor: 'pointer',
  fontWeight: 700
})

export const NewPMButton = () => ({
  fontSize: pxToRem(14),
  minHeight: `${pxToRem(30)}`,
  padding: `${pxToRem(0)} ${pxToRem(36)}`,
  width: pxToRem(99),
})

export const BooleanBox = () => ({
  alignItems: 'center',
  display: 'flex',
  gap: pxToRem(8),
})

export const CheckboxItem = ({palette: {secondary, table}}) => ({
  '&.MuiCheckbox-root': {
    padding: 0,
  },
  '& .MuiSvgIcon-root': {
    border: `1px solid ${table.border}`,
    borderRadius: '4px',
    height: pxToRem(16),
    width: pxToRem(16),
  },
  '&.Mui-checked': {
    '& .MuiSvgIcon-root': {
      backgroundImage: `url(${check}),linear-gradient(195deg, ${secondary.main},${secondary.main})`,
      border: 'none',
      borderRadius: '4px',
      color: secondary.main,
      height: pxToRem(16),
      width: pxToRem(16),
    },
  },
})

export const CheckboxValue = () => ({
  fontSize: pxToRem(14),
  fontWeight: 400,
  pt: pxToRem(3),
})